import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IChangeTrackerFixedPaymentsPayload } from '../types';
import {
  AFFILIATE_CHANGE_TRACKER_FIXED_PAYMENTS_API_URL,
  AFFILIATE_CHANGE_TRACKER_FIXED_PAYMENTS_MUTATION,
} from '../constants';
import { AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS } from '../submodules/fixed-tracker-payments/constants';

export default function useChangeTrackerFixedPaymentsMutation(): IContextMutationResult<void, Error, IChangeTrackerFixedPaymentsPayload> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IChangeTrackerFixedPaymentsPayload>({
    mutationKey: [AFFILIATE_CHANGE_TRACKER_FIXED_PAYMENTS_MUTATION],
    mutationFn: ({ id, ...payload }) => fetchPut<void>(
      AFFILIATE_CHANGE_TRACKER_FIXED_PAYMENTS_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS.HISTORY_CHANGES_EDIT,
        urlParams: {
          id,
        },
      },
    ),
    onSuccess() {
      displayPresetToast('edited');
    },
  });
}
